import { createObservableDataAction, IAction, IActionContext } from '@msdyn365-commerce/core';
import {
    AsyncResult,
    CacheType,
    DataServiceQuery,
    IActionInput,
    IContext,
    IDataServiceRequest,
    IQueryResultSettings,
    callActionOrExecute
} from '@msdyn365-commerce/retail-proxy';
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
import { ProductListWithLineCount } from '../modules/dlvry-counting-lists/actions/get-counting-list-with-line-count';

export class GetCountingListsInput implements IActionInput {
    public shouldCacheOutput = (): boolean => false;

    public getCacheKey = () => 'get-counting-lists';
    public getCacheObjectType = () => 'counting-lists';
    public dataCacheType = (): CacheType => 'request';
}

const createInput = (): GetCountingListsInput => {
    return new GetCountingListsInput();
};

export function createGetCountingListsInput(
    queryResultSettings: IQueryResultSettings,
    customerId: string,
    countingListId: string
): IDataServiceRequest {
    const query = new DataServiceQuery('DlvryProductLists', 'DlvryProductList');
    return query.createDataServiceRequestForOperation(
        'GetCountingLists',
        true,
        EntityClasses.ProductListClass,
        'true',
        {
            bypassCache: 'none',
            returnEntity: 'ProductListWithLineCount'
        },
        {
            customerId,
            countingListId
        }
    );
}

export function getCountingListsAsync(context: IContext, customerId: string, countingListId?: string): AsyncResult<ProductListWithLineCount[]> {
    const request = createGetCountingListsInput(context.queryResultSettings || {}, customerId, countingListId || '');
    return callActionOrExecute<ProductListWithLineCount[]>(request, context.callerContext);
}

export async function getCountingListsAsyncAction(input: GetCountingListsInput, context: IActionContext): Promise<ProductListWithLineCount[]> {
    if (!context.requestContext.user.isAuthenticated) {
        throw new Error('Unable to get counting lists. User is not authenticated.');
    }

    const countingLists = await getCountingListsAsync(
        { callerContext: context },
        context.requestContext.user.customerAccountNumber || '',
        ''
    );

    // We need to explicitly set LineCount so that mobx will register it as a observable property
    return countingLists.map(x => ({ ...x, LineCount: -1 }));
}

export const getCountingLists = createObservableDataAction({
    id: 'dlvry/get-counting-lists',
    action: <IAction<ProductListWithLineCount[]>>getCountingListsAsyncAction,
    input: createInput
});

export default getCountingLists;
